import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {VehicleForm as VFKit} from '../VehicleForm';

export function MileageGroup() {
  const {vehicleId} = useVehicleFormContext();

  return (
    <>
      <VFKit.SimpleMileageField name="mileage" vehicleId={vehicleId} />
      <VFKit.RealMileageInput />
    </>
  );
}
